import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import HomePage from "@/pages/HomePage";
import JobsPage from "@/pages/JobsPage";
import AboutUs from "@/pages/AboutUs";
import PartnershipPage from "@/pages/PartnershipPage";
import TrackApplication from "@/pages/TrackApplication";
import TrackApplicationStatus from "@/pages/TrackApplicationStatus";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import VendorLogin from "@/pages/VendorLogin";
import VendorDashboard from "@/pages/VendorDashboard";
import { Toaster } from "@/components/ui/sonner";
import CookieConsent from "@/components/CookieConsent";
import { initAnalytics, trackPageView } from "@/lib/analytics";
import { ADMIN_BASE_PATH } from "@/lib/adminApi";
import { VENDOR_BASE_PATH } from "@/lib/vendorApi";

// Must match the <title> in public/index.html - the tab title outside
// either portal resets to this when navigating away (SPA client-side
// routing never reloads index.html, so nothing else would reset it).
const DEFAULT_TITLE = "Zeevogo | Overseas Jobs";

function AppLayout() {
  const location = useLocation();
  const isAdminRoute = location.pathname.startsWith(`/${ADMIN_BASE_PATH}`);
  const isVendorRoute = location.pathname.startsWith(`/${VENDOR_BASE_PATH}`);

  useEffect(() => {
    if (isAdminRoute) {
      document.title = "Zeevogo | Admin Portal";
    } else if (isVendorRoute) {
      document.title = "Zeevogo | Vendor Portal";
    } else {
      document.title = DEFAULT_TITLE;
    }
  }, [isAdminRoute, isVendorRoute]);

  useEffect(() => {
    initAnalytics();
  }, []);

  useEffect(() => {
    if (isAdminRoute || isVendorRoute) return;
    trackPageView(location.pathname, document.title);
  }, [location.pathname, isAdminRoute, isVendorRoute]);

  return (
    <>
      {!isAdminRoute && !isVendorRoute && <Header />}
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/jobs" element={<JobsPage />} />
        <Route path="/about-us" element={<AboutUs />} />
        <Route path="/partnership" element={<Navigate to="/partnership/agency" replace />} />
        <Route path="/partnership/:type" element={<PartnershipPage />} />
        <Route path="/agency-partnership" element={<Navigate to="/partnership/agency" replace />} />
        <Route path="/agent-partnership" element={<Navigate to="/partnership/agent" replace />} />
        <Route path="/tracker" element={<TrackApplication />} />
        <Route path="/tracker/status" element={<TrackApplicationStatus />} />
        <Route path={`/${ADMIN_BASE_PATH}`} element={<AdminLogin />} />
        <Route path={`/${ADMIN_BASE_PATH}/dashboard`} element={<AdminDashboard />} />
        <Route path={`/${VENDOR_BASE_PATH}/login`} element={<VendorLogin />} />
        <Route path={`/${VENDOR_BASE_PATH}/dashboard`} element={<VendorDashboard />} />
      </Routes>
      {!isAdminRoute && !isVendorRoute && <Footer />}
      {!isAdminRoute && !isVendorRoute && <CookieConsent />}
      <Toaster />
    </>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AppLayout />
      </BrowserRouter>
    </div>
  );
}

export default App;
